import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createElementVNode as _$ce, noop as _$no } from 'intact-vue-next';
import { makeGroupStyles } from './styles';
import { getRestProps } from '../utils';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    children = _this$get.children,
    label = _this$get.label,
    className = _this$get.className;
  var _this$select$get = this.select.get(),
    card = _this$select$get.card;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-select-group"] = true, _classNameObj[className] = className, _classNameObj[makeGroupStyles(k)] = true, _classNameObj);
  return _$cv('div', _extends({}, getRestProps(this), {
    'className': _$cn(classNameObj)
  }), [!card ? _$ce(2, 'div', (_$blocks['label'] = function ($super) {
    return label;
  }, __$blocks['label'] = function ($super, data) {
    var block = $blocks['label'];
    var callBlock = function callBlock() {
      return _$blocks['label'].call($this, $super, data);
    };
    return block ? block.call($this, callBlock, data) : callBlock();
  }, __$blocks['label'](_$no)), 0, _$cn(k + "-select-group-label")) : undefined, children]);
}
;